import React, { Fragment, useState, useEffect } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faSave,
  faTimes,
  faCheck } from
"@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router";
import { Modal, ModalBody } from "reactstrap";
import "./CannedMessages.css";
import "../AdminPages.css";

const MessageModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck} />
                
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const CreateCannedMessages = () => {
  let history = useHistory();
  let location = useLocation();
  const messageId = location?.pathname?.split("/").pop();
  const [input, setInput] = useState({
    language: "en",
    schoolId: "",
    ack: "0",
    answerText: "",
    ackError: false
  });
  const [body, setBody] = useState("");
  const [esBody, setEsBody] = useState("");
  const [subject, setSubject] = useState("");
  const [esSubject, setEsSubject] = useState("");
  const [messageData, setMessageData] = useState();
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newInURL, setNewInURL] = useState(false);
  const [showAckInput, setShowAckInput] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const getCannedMessage = (id) => {
    const searchParam = new URLSearchParams(location.search);
    setLoading(true);
    if (searchParam.get("new") === "1") {
      setNewInURL(true);
      GetAdminService.getCannedMessage(id)
      .then((data) => {
        setMessageData(data.data);
        setInput({
          ...input,
          schoolId: data?.data?.school
        });
        setLoading(false);
      })
      .catch((_error) => {
        setLoading(false);
      });
    } else {
      GetAdminService.getMessage(id)
      .then((data) => {
        setMessageData(data.data);
        setAnswers(Object.values(data.data.answers));
        let messages = data.data.messages;
        setBody(messages["en"]["body"]);
        setEsBody(messages?.es?.body);
        setSubject(messages["en"]["subject"]);
        setEsSubject(messages?.es?.subject);
        setInput({
          ...input,
          schoolId: data?.data?.school
        });
        setLoading(false);
      })
      .catch((_error) => {
        setLoading(false);
      });
    }
  };

  const translateText = async (lan) => {
    let obj = { to: lan };
    setInput({ ...input, language: lan });
    if (lan === "es") {
      if (body !== "" && esBody === "") {
        obj.text = body;
        translateAPI(obj, setEsBody);
      }
      if (subject !== "" && esSubject === "") {
        obj.text = subject;
        translateAPI(obj, setEsSubject);
      }
    } else {
      if (body === "" && esBody !== "") {
        obj.text = esBody;
        translateAPI(obj, setBody);
      }
      if (subject === "" && esSubject !== "") {
        obj.text = esSubject;
        translateAPI(obj, setSubject);
      }
    }
  };

  const translateAPI = (obj, setTranslate) => {
    setLoading(true);
    GetAdminService.translateText(obj)
    .then((data) => {
      setTranslate(data.data?.tr);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const cancelNewCannedMessage = () => {
    let newObj = {
      answers: answers,
      id: messageId,
      languages: ["en", "es"],
      messages: {
        en: {
          body: body,
          subject: subject
        },
        es: {
          body: esBody,
          subject: esSubject
        }
      },
      resource_uri: "",
      school: input.schoolId,
      originalElement: messageData
    };
    GetAdminService.cancelNewCannedMessage(newObj, messageId)
    .then((_data) => {
    })
    .catch(() => {});
  };

  const deleteCannedMessage = () => {
    GetAdminService.deleteCannedMessage(messageId)
    .then((_data) => {
      history.push(`/admin/canned/${messageData?.school}`);
    })
    .catch(() => {});
  };

  const saveCannedMessage = () => {
    let newObj = {};
    answers.map((item, index) => {
      newObj[index + 1] = item;
    });
    let obj1 = {
      messages: {
        en: {
          body: body,
          subject: subject
        },
        es: {
          body: esBody,
          subject: esSubject
        }
      },
      answers: newObj
    };
    GetAdminService.saveCannedMessage(obj1, messageId)
    .then((_data) => {
      history.push(`/admin/canned/${messageData?.school}`);
    })
    .catch(() => {});
  };

  const addAnswer = () => {
    if (input.answerText === "") {
      setInput({ ...input, ackError: true });
    } else {
      setShowAckInput(false);
      let newArrItem = {
        ack: input.ack,
        ackError: false,
        ackText: input.ack === "0" ? "feedback" : "ack",
        text: {
          en: input.answerText,
          es: ""
        },
        textError: false
      };
      setAnswers([...answers, newArrItem]);
      setInput({ ...input, answerText: "", ack: "0" });
    }
  };

  useEffect(() => {
    getCannedMessage(messageId);
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          {loading ?
          <CustomLoader /> :

          <div className="csv-import-container Create-Canned">
              <div className="admin-students-page-header">
                <h2>Canned Messages</h2>
              </div>

              <div className="admin-page-section">
                <div className="admin-page-card canned-edit-card">
                  <div className="admin-page-form-row">
                    <label>
                      Language
                      <span className="required-marker">*</span>
                    </label>
                    <div className="canned-lang-toggle">
                      <button
                      type="button"
                      onClick={() => translateText("en")}
                      className={
                      input.language === "en" ?
                      "canned-lang-btn active" :
                      "canned-lang-btn"}>

                      
                        en
                      </button>
                      <button
                      type="button"
                      onClick={() => translateText("es")}
                      className={
                      input.language === "es" ?
                      "canned-lang-btn active" :
                      "canned-lang-btn"}>

                      
                        es
                      </button>
                    </div>
                    <p className="canned-lang-hint">
                      Select language to translate subject and body.
                    </p>
                  </div>

                  {input.language === "en" ?
                <>
                      <div className="admin-page-form-row">
                        <label>
                          Subject (en)
                          <span className="required-marker">*</span>
                        </label>
                        <input
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      type="text"
                      placeholder="Type the message subject"
                      className="canned-edit-input" />
                    
                      </div>
                      <div className="admin-page-form-row">
                        <label>
                          Body (en)
                          <span className="required-marker">*</span>
                        </label>
                        <textarea
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                      className="canned-edit-input"
                      placeholder="Type the message content here"
                      rows="10" />
                    
                      </div>
                    </> :

                <>
                      <div className="admin-page-form-row">
                        <label>
                          Subject (es)
                          <span className="required-marker">*</span>
                        </label>
                        <input
                      value={esSubject}
                      onChange={(e) => setEsSubject(e.target.value)}
                      type="text"
                      placeholder="Type the message subject"
                      className="canned-edit-input" />
                    
                      </div>
                      <div className="admin-page-form-row">
                        <label>
                          Body (es)
                          <span className="required-marker">*</span>
                        </label>
                        <textarea
                      value={esBody}
                      onChange={(e) => setEsBody(e.target.value)}
                      className="canned-edit-input"
                      placeholder="Type the message content here"
                      rows="10" />
                    
                      </div>
                    </>}
                

                  <div className="admin-page-form-row">
                    <label>
                      Feedback / clarification
                      <span className="required-marker">*</span>
                    </label>
                    <div className="canned-ack-box">
                      <button
                      type="button"
                      className="canned-ack-add"
                      onClick={() => setShowAckInput(true)}>
                      
                        <FontAwesomeIcon icon={faPlus} />
                        Add a feedback/clarification option
                      </button>
                      {showAckInput &&
                    <div className="canned-ack-editor">
                          <select
                        name="ack"
                        value={input.ack}
                        onChange={(e) =>
                        setInput({ ...input, ack: e.target.value })}>

                        
                            <option value="0">Feedback</option>
                            <option value="1">Ack</option>
                          </select>
                          <input
                        value={input.answerText}
                        onChange={(e) =>
                        setInput({
                          ...input,
                          answerText: e.target.value,
                          ackError: false
                        })}

                        type="text"
                        placeholder="Option text"
                        className={
                        input.ackError ?
                        "input-error canned-edit-input" :
                        "canned-edit-input"} />

                      
                          <button
                        type="button"
                        className="canned-ack-icon-btn ok"
                        onClick={addAnswer}
                        aria-label="Add option">
                        
                            <FontAwesomeIcon icon={faCheck} />
                          </button>
                          <button
                        type="button"
                        className="canned-ack-icon-btn cancel"
                        onClick={() => {
                          setShowAckInput(false);
                          setInput({
                            ...input,
                            answerText: "",
                            ack: "0"
                          });
                        }}
                        aria-label="Cancel">
                        
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </div>}
                    
                      {answers?.map((item, index) =>
                    <div
                      key={index}
                      className="canned-ack-item">
                      
                          <span className="canned-ack-type">
                            {item.ack == "0" ?
                        <span className="feedback-mark">?</span> :

                        <FontAwesomeIcon icon={faCheck} color="#1395f2" />}
                        
                          </span>
                          <span className="canned-ack-text">
                            {item.text.en}
                          </span>
                          <button
                        type="button"
                        className="canned-ack-icon-btn cancel"
                        onClick={() => {
                          answers.splice(index, 1);
                          setAnswers([...answers]);
                        }}
                        aria-label="Remove option">
                        
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </div>
                    )}
                    </div>
                  </div>

                  <div className="canned-edit-actions">
                    <button
                    type="button"
                    disabled={!subject || !body}
                    className={
                    !subject || !body ?
                    "drawer-btn-save disabled" :
                    "drawer-btn-save"}

                    onClick={saveCannedMessage}>
                    
                      <FontAwesomeIcon icon={faSave} />
                      Save
                    </button>
                    {!newInURL &&
                  <button
                    type="button"
                    className="drawer-btn-delete"
                    onClick={() => setOpenMessageModal(true)}>
                    
                        <FontAwesomeIcon icon={faTrash} />
                        Remove
                      </button>}
                  
                    <button
                    type="button"
                    className="canned-cancel-btn"
                    onClick={() => {
                      if (newInURL) cancelNewCannedMessage();
                      history.push(`/admin/canned/${messageData?.school}`);
                    }}>
                    
                      <FontAwesomeIcon icon={faTimes} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>}
          
          {openMessageModal &&
          <MessageModal
            setIsOpen={setOpenMessageModal}
            isOpen={openMessageModal}
            data={{
              function1: deleteCannedMessage,
              message: "Are you sure you want to delete?"
            }} />}

          
        </div>
      </div>
    </Fragment>);

};

export default CreateCannedMessages;